import _ from 'lodash'

export function paginate(items, pageNumber, pageSize) {
  const startIndex = (pageNumber - 1) * pageSize
  if (startIndex > items.length) {
    return _(items).slice(0).take(pageSize).value()
  }
  return _(items).slice(startIndex).take(pageSize).value()
}
